import { Form, Row, Col, Typography } from 'antd';

import {
  CheckOutlined,
  CloseOutlined,
  LoadingOutlined,
} from '@ant-design/icons';

import {
  GroupElementWrapper,
  HeaderGroupElement,
} from 'pages/product-full-view/shared/components';

export const RequiredPropertiesForm = ({ children, ...otherProps }) => {
  return <Form {...otherProps}>{children}</Form>;
};

export const RequiredPropertiesSection = ({
  header,
  children,
  ...otherProps
}) => {
  return (
    <>
      <HeaderGroupElement
        className='required-section__header'
        header={header}
        {...otherProps}
      />
      <GroupElementWrapper>{children}</GroupElementWrapper>
    </>
  );
};

export const RequiredModuleName = ({ moduleName, style, ...otherProps }) => {
  return (
    <Typography.Title
      level={5}
      style={{ fontSize: 14, color: '#184e77', marginBottom: 0, ...style }}
      {...otherProps}
    >
      {moduleName}
    </Typography.Title>
  );
};

export const RequiredPropertyItem = ({ children, ...otherProps }) => {
  return (
    <Row
      style={{ paddingLeft: 8, minHeight: 36 }}
      align='middle'
      gutter={[0, 12]}
      {...otherProps}
    >
      {children}
    </Row>
  );
};

export const RequiredPropertyName = ({
  propertyName,
  isError,
  ...otherProps
}) => {
  return (
    <Col span={16} {...otherProps}>
      <Typography.Text strong type={isError ? 'danger' : undefined}>
        {propertyName}
      </Typography.Text>
    </Col>
  );
};

const StatusIcon = {
  loading: <LoadingOutlined style={{ fontSize: 16 }} />,
  success: (
    <CheckOutlined
      style={{
        color: '#52C41A',
        fontSize: 16,
      }}
    />
  ),
  error: (
    <CloseOutlined
      style={{
        color: '#f5222d',
        fontSize: 16,
      }}
    />
  ),
};

export const RequiredPropertyStatus = ({ status, ...otherProps }) => {
  const Icon = StatusIcon[status] ?? null;

  return (
    <Col flex='32px' {...otherProps}>
      {Icon}
    </Col>
  );
};
